var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{attrs:{"type":"number","controls":false,"placeholder":"","disabled":_vm.disabled},model:{value:(_vm.numberModel),callback:function ($$v) {_vm.numberModel=$$v},expression:"numberModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }